<template>
    <div id="app" :data-key="key">
        <router-view :key="key"/>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'app',
        computed: {
            ...mapState({
                key: state => state.router.appRenderKey,
            }),
        },
    };

</script>
